/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".shared-account-modal .modal-dialog{max-width:500px}  .shared-account-modal .modal-content{border-radius:24px;overflow:hidden;border:none}.header[_ngcontent-%COMP%]{height:67px;width:100%;background-color:#0080ff;margin-bottom:80px}.icon[_ngcontent-%COMP%]{height:80px;width:80px;margin:0 auto;background-color:#f2f8ff;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;border-radius:50%;-webkit-transform:translateY(50%);transform:translateY(50%)}.title[_ngcontent-%COMP%]{text-align:center;font-family:PoppinsSemiBold}.body[_ngcontent-%COMP%], .title[_ngcontent-%COMP%]{font-size:16px}.body[_ngcontent-%COMP%]{line-height:24px;margin:32px}.close-button[_ngcontent-%COMP%]{display:block;margin-inline:auto;margin-bottom:32px}"];
export { styles as styles };
//# sourceMappingURL=shared-account-dialog.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/login/shared-account-dialog/shared-account-dialog.component.scss.shim.ngstyle.js
// module id = 1289
// module chunks = 26 27 28